import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { toggleLikedRecomment, loadDetailPost } from "redux/modules/postSlice";

function LikeToggleRecomment({ post, recomment, likeCountFunc }) {
  const dispatch = useDispatch();

  const replaceNumber = Number(recomment.likeCount.replace(/(^0+)/, ""));
  const [likeCount, setLikeCount] = useState(replaceNumber);
  const [isLiked, setIsLiked] = useState(recomment.isLiked);

  const isMounted = useRef(false);
  useEffect(() => {
    // 이 조건은 컴포넌트가 처음 Mount 되었을 때 아무 동작도 하지 않게 하려고 걸어준 것
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      likeCountFunc(likeCount);
    }
  }, [likeCount]);

  useEffect(() => {
    setIsLiked(recomment.isLiked);
    setLikeCount(replaceNumber);
    // dispatch(loadDetailPost(post.boardId));
  }, [dispatch, recomment.isLiked, replaceNumber]);

  const onClickToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLikedRecomment(recomment.recommentId));
  }, [dispatch, setLikeCount, recomment]);

  const onClickToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLikedRecomment(recomment.recommentId));
  }, [dispatch, setLikeCount, recomment]);

  return (
    <>
      {isLiked ? (
        <img
          src="/img/likedFull.svg"
          alt="좋아요"
          onClick={onClickToggleUnLiked}
        />
      ) : (
        <img src="/img/liked.svg" alt="좋아요" onClick={onClickToggleLiked} />
      )}
    </>
  );
}

export default LikeToggleRecomment;
